import { Keywords } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { openLockedFeatureHook } from "app/components/React/QuickSearch/pageData/openLockedFeatureHook";
import type { Recent } from "app/custom-hooks/useRecentsHook";
import { createKeywordUrl } from "app/pages/activation/components/HomeSearch/helpers/createKeywordUrl";
import { redirectToUrl } from "app/pages/activation/components/HomeSearch/helpers/redirectToUrl";
import { recentActivityDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";
import { activationTracking } from "app/pages/activation/services/tracking";

import { RecentItemTitle } from "./RecentItemTitle";
import * as SC from "./styles";

interface IRecentKeywordItemProps {
    item: Recent;
    isLocked?: boolean;
}

export const RecentKeywordItem = ({ item, isLocked = false }: IRecentKeywordItemProps) => {
    const { data } = item;
    const track = activationTracking.homePageWithData;

    const { mainItem, stateName, pageTitle } = data;
    const url = createKeywordUrl(mainItem, stateName);

    const onClick = () => {
        if (isLocked) {
            openLockedFeatureHook(stateName);
            return;
        }

        track.trackClickRecent(url);
        redirectToUrl(url);
    };

    return (
        <SC.Item
            onClick={onClick}
            data-automation={recentActivityDataAutomation.keywordItem}
        >
            <SC.IconContainer
                hasOneIcon
                data-automation={recentActivityDataAutomation.itemIcon}
            >
                <SC.KeywordIconContainer>
                    <Keywords
                        color={colorsPalettes.carbon[200]}
                        size="xs"
                    />
                </SC.KeywordIconContainer>
            </SC.IconContainer>

            <SC.InfoContainer>
                <RecentItemTitle
                    pageTitle={pageTitle}
                    isLocked={isLocked}
                    dataAutomation={recentActivityDataAutomation.itemPage}
                />

                <SC.CompetitorsContainer data-automation={recentActivityDataAutomation.itemSearchResults}>
                    {mainItem}
                </SC.CompetitorsContainer>
            </SC.InfoContainer>
        </SC.Item>
    );
};
